import React from 'react'
interface NameProps {
  name: string
  meta: string
}

const Name = ({ name, meta }: NameProps) => {
  return (
    <div>
      <strong>{name}</strong> <br />
      {meta}
    </div>
  )
}

export default Name
